import React, {useMemo} from 'react';
import {HashRouter, Outlet, Route, useLocation} from 'react-router-dom';
import styled from 'styled-components';

import LogoBar from 'components/LogoBar';
import NavBar from 'components/NavBar';
import TransitionRoutes from 'components/TransitionRoutes';
import ImprintScreen from 'screens/ImprintScreen';
import MapScreen from 'screens/MapScreen';
import MenuScreen from 'screens/MenuScreen';
import SlideScreen from 'screens/SlideScreen';
import TableScreen from 'screens/TableScreen';
import configuration, {SCREEN, ScreenType} from 'configuration';

const createScreen = (screen: ScreenType) => {
  switch (screen.type) {
    case SCREEN.MENU:
      return <MenuScreen path={screen.path} items={screen.items} />;

    case SCREEN.SLIDE:
      return <SlideScreen path={screen.path} items={screen.items} />;

    case SCREEN.TABLE:
      return <TableScreen path={screen.path} items={screen.items} />;

    case SCREEN.MAP:
      return <MapScreen path={screen.path} />;

    case SCREEN.IMPRINT:
      return <ImprintScreen />;
  }
};

const App = () => {
  const screens = useMemo(() => configuration.screenTypes, []);

  return (
    <HashRouter>
      <TransitionRoutes>
        <Route path="/" element={<ScreenContainer />}>
          {screens.map(screen => (
            <Route
              key={screen.path}
              index={screen.path === '/' ? true : undefined}
              path={screen.path === '/' ? undefined : screen.path}
              element={createScreen(screen)}
            />
          ))}
        </Route>
      </TransitionRoutes>
    </HashRouter>
  );
};
export default App;

const ScreenContainer = () => {
  const location = useLocation();
  const showLogos = useMemo(
    () => (location.pathname === '/' ? configuration.showLogos : []),
    [location],
  );

  return (
    <Container>
      <NavBar />
      <Outlet />
      <LogoBar showLogos={showLogos} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;
